<template>
  <div>
    <h3>专家详情</h3>
    <div class="people">
      <div class="people-content">
        <b-card
          :img-src="people.portrait"
          :img-alt="people.name"
          img-left
          border-variant="light"
        >
          <b-card-body>
            <b-card-text class="people-detail">
              <span class="name">{{people.name}}</span>
              <span v-if="people.position">{{people.position}}</span>
              <br />
              <div class="contact-info">
                <span v-if="people.address">办公室：{{people.address}}</span>
                <br />
                <span v-if="people.email">邮 箱：{{people.email}}</span>
                <br />
                <span v-if="people.phone">电 话：{{people.phone}}</span>
              </div>
            </b-card-text>
          </b-card-body>
        </b-card>
      </div>
      <div class="people-intro" v-if="people.intro">
        <div v-html="people.intro"></div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data: function () {
    return {
      people: "",
    };
  },
  created: function () {
    this.get_people_detail(this.$route.query.id);
  },
  methods: {
    get_people_detail(id) {
      let url = "people/?id=" + id;
      this.$http.get(url).then((response) => {
        this.people = response.data[0];
      });
    },
  },
};
</script>
<style lang="scss" scoped>
img {
  margin-top: 10px;
  margin-left: 10px;
  width: 158px;
  height: 200px;
  box-shadow: 0 4px 6px 0 rgba(0, 0, 0, 0.2), 0 5px 10px 0 rgba(0, 0, 0, 0.15);
}
.people {
  padding: 0;
  .people-content {
    margin-bottom: 5px;
  }
  .people-detail {
    margin: 25px 0 0 0;
    padding: 5px 30px;
    .name {
      color: #05386b;
      font-size: 25px;
      font-weight: bold;
      padding-right: 0.5em;
    }
    .contact-info {
      margin-top: 20px;
      padding: 10px 0;
      line-height: 2.5rem;
    }
  }
  .people-intro {
    padding: 20px;
  }
}
span {
  font-size: 16px;
  margin-right: 5px;
}
.card {
  background-color: transparent;
  padding: 10px;
  border: none;
  .card-body {
    padding-top: 0;
  }
}
</style>
